import React from 'react';
import Icon from 'react-icon-base';
import { any, number, oneOfType, string } from 'prop-types';

/* prettier-ignore */
const ArrowEndPointIconIcon = ({
  className, color, height, size, style, width, ...restProps
}) => (
  /* eslint-disable */
  <Icon
    className={className}
    color={color}
    height={height}
    size={size}
    style={style}
    viewBox="0 0 16 16"
    width={width}
    {...restProps}
  >
    <g>
      <path d="M15.6951 8.71917L10.707 13.7072C10.316 14.0982 9.68402 14.0982 9.29302 13.7072C9.09802 13.5122 9.00002 13.2562 9.00002 13.0002C9.00002 12.7442 9.09802 12.4882 9.29302 12.2933L12.586 9.00025H0.410034V7.00025H12.586L9.29302 3.70725C8.90202 3.31625 8.90202 2.68425 9.29302 2.29325C9.68402 1.90225 10.316 1.90225 10.707 2.29325L15.6887 7.27496C15.8805 7.45715 16 7.71461 16 8C16 8.28221 15.8831 8.53735 15.6951 8.71917Z"/>
    </g>
  </Icon>
  /* eslint-enable */
);

ArrowEndPointIconIcon.propTypes = {
  className: string,
  color: string,
  height: oneOfType([string, number]),
  size: oneOfType([string, number]),
  style: any, // eslint-disable-line react/forbid-prop-types
  width: oneOfType([string, number]),
};

export default ArrowEndPointIconIcon;
